import React from "react";
//#region types
import { TodoCardProps } from "models/propTypes/todoPropTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { FormHandles } from "models/propTypes/genericFormProps";
//endregion
//#region components
import TopTodoCard from "../../_partials/topTodoCard";
import { GenericCommentsView, TitledContainerInner, EntityCardContent, Profiles } from "components/common";
import {
  IncomingInvoiceFooter,
  IncomingInvoiceTodoSelectionFormContainer,
  useIncomingInvoiceTodoHelpers,
  useQuickActions,
  useOnViewInfo,
  useIncomingInvoiceFileViewer,
  IncomingInvoiceViewAlerts,
  useIncomingInvoiceTodoFormHelpers,
  IncomingInvoiceInternationalPaymentViewFooter,
} from "components/incomingInvoice";
import { Grid } from "@mui/material";
//#endregion
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const IncomingInvoiceTodoFinalApprove: React.FC<TodoCardProps> = (props) => {
  const invoice = props.item.incomingInvoice!;
  const formRef = React.useRef<FormHandles>(null);

  const [isInternationalPaymentView, setIsInternationalPaymentView] = React.useState<boolean>(false);
  const [isAccepted, setIsAccepted] = React.useState<boolean>(false);

  const { isFormValid } = useIncomingInvoiceTodoFormHelpers(invoice);

  const { reloadTodo, onUpdatePaymentSuccess, loading } = useIncomingInvoiceTodoHelpers(
    invoice!,
    props.onActionSuccess
  );

  const onViewInfoClick = useOnViewInfo(invoice.id, formRef);

  const isInternationalPayment = invoice?.isInternationalPayment ?? false;
  const bicRequired = (isInternationalPayment && !invoice?.isSEPAPayment) ?? false;

  const dueDate = invoice.dueDate ? DateHelper.formatDate(invoice.dueDate) : "";

  const submitInvoiceForm = (submitFunc?: (values: any) => Promise<any>) => {
    return (formRef.current && formRef.current.submit(submitFunc)) || new Promise<void>((resolve) => resolve());
  };

  const onToggleInternationalPaymentView = async (show: boolean) => {
    if (
      show &&
      !(await isFormValid(formRef, isInternationalPayment, invoice?.isSEPAPayment!))
    ) {
      return;
    }
    setIsInternationalPaymentView(show);
  };

  const onToggleChange = (e: React.ChangeEvent<any>, checked: boolean) => {
    setIsAccepted(checked);
  };

  const quickActions = useQuickActions(invoice.id, props.onActionSuccess, reloadTodo);
  const fileViewerComponent = useIncomingInvoiceFileViewer(invoice?.id, invoice?.attachments);

  return (
    <EntityCardContent
      topTodoCard={
        <TopTodoCard
          item={props.item}
          descriptionHeadingOne={LocalizationHelperInstance.getFormattedCurrency(
            invoice?.amountWithSign ?? 0,
            invoice?.currency
          )}
          descriptionHeadingTwo={
            <Profiles.SupplierProfileLink
              id={invoice?.supplier?.id}
              name={invoice?.supplierName ?? ""}
              className={cssExports.titleLink}
            />
          }
          descriptionheadingThree={
            <Grid container direction="column">
              {invoice?.oCR ? (
                <Grid item>
                  {`${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.IncomingInvoice.OCR)}: ${
                    invoice?.oCR
                  }`}
                </Grid>
              ) : (
                <></>
              )}
              <Grid item>
                {`${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.ApprovedBy)}: ${
                  invoice?.certifyPersonName ?? "-"
                }`}
              </Grid>
            </Grid>
          }
          footerText={`${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Due_Date)}: ${dueDate}`}
          onViewAllClick={onViewInfoClick}
          quickActions={quickActions}
        />
      }
      todoMainSection={
        <TitledContainerInner
          header={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.CheckInformation)}
          stepCounterProps={
            isInternationalPayment ? { currentStep: isInternationalPaymentView ? 2 : 1, totalSteps: 2 } : undefined
          }
        >
          <IncomingInvoiceTodoSelectionFormContainer
            ref={formRef}
            invoice={invoice!}
            fileViewer={fileViewerComponent}
            isInternationalPaymentView={isInternationalPaymentView}
            isInternationalPayment={isInternationalPayment}
            bicRequired={bicRequired}
          />
          {isInternationalPaymentView ? (
            <IncomingInvoiceInternationalPaymentViewFooter isAccepted={isAccepted} onChange={onToggleChange} />
          ) : (
            <></>
          )}
        </TitledContainerInner>
      }
      infoViewer={fileViewerComponent}
      footer={
        <IncomingInvoiceFooter
          invoice={invoice!}
          invoiceFormSubmitHandler={submitInvoiceForm}
          reloadHandler={reloadTodo}
          markAsDoneHandler={props.onActionSuccess}
          onUpdatePaymentDialogSuccessHandler={onUpdatePaymentSuccess}
          onShowInternationalPaymentView={onToggleInternationalPaymentView.bind(null, true)}
          isInternationalPaymentView={isInternationalPaymentView}
          isInternationalPayment={isInternationalPayment}
          hideSave
          disableSuccessMessages
          isTodoCardStep
          disableAccept={isInternationalPaymentView && !isAccepted}
          showAcceptButtonTooltip={isInternationalPaymentView && !isAccepted}
          acceptButtonTooltipText={LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.IncomingInvoice.InternationalPaymentAndAddressToolTipText
          )}
        />
      }
      loading={loading}
    >
      <GenericCommentsView parentId={invoice!.id} type={WintSuperkollAPIModel.GenericCommentType.IncomingInvoice} />
      {invoice ? <IncomingInvoiceViewAlerts invoice={invoice} /> : <></>}
    </EntityCardContent>
  );
};

export default IncomingInvoiceTodoFinalApprove;
